import request from '@/utils/request'
const BASE_URL = '/Expcompany'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },

  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  getMaxOrderId(storeId) {
    return request({
      url: BASE_URL + '/GetMaxOrderId',
      method: 'get',
      params: { storeId }
    })
  },

}